import CampaignService from '../../../respona_api/generated/campaign_pb_service';

const service = (function () {
  let instance = null;

  return {
    getInstance: (): CampaignService.CampaignServiceClient => {
      if (!instance) {
        // @ts-ignore
        instance = new CampaignService.CampaignServiceClient(API_HOST);
      }

      return instance;
    },
  };
})();

export default service;
